import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  resultTitle: {
    lineHeight: '16px',
    letterSpacing: '0.4px'
  }
});

export default useStyles;
